import React from "react";
import esignBanner from "../../assets/icons/esignBanner.jpeg";
import PendingModules from "../ESign/PendingModulesList/PendingModulesList";
import GlobalStore from "../store/globalStore";
import cleverTapEvents from "../../config/cleverTapEvents";
import useQuery from "../../customHooks/useQuery";
import { useLocation } from "react-router-dom";
import KRAAuthenticateForm from "./KRAAuthenticateForm";
import { dashboardUrl } from "../utils/constants";
const KraAuthenticateHome = (props: any) => {
  const quryParams = useQuery();
  const location = useLocation();
  const UTM_SOURCE = quryParams.get("utm_source")
    ? quryParams.get("utm_source")
    : "";
  const UTM_MEDIUM = quryParams.get("utm_medium")
    ? quryParams.get("utm_medium")
    : "";
  const UTM_CAMPAIGN = quryParams.get("utm_campaign")
    ? quryParams.get("utm_campaign")
    : "";
  const [pendingModules, setPendingModules] =
    React.useState<Array<{ name: string; navUrl: string }>>();
  const [proceedToAutheticate, setProceedToAutheticate] =
    React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [errCode, setErrCode] = React.useState<any>("");
  React.useEffect(() => {
    checkPendingModules();
    // window.sessionStorage.setItem("stageInfoId", "10");
  }, []);
  function checkPendingModules(): Array<{ name: string; navUrl: string }> {
    let arr: Array<{ name: string; navUrl: string }> = [];
    GlobalStore.leftNavBarState.forEach((module) => {
      if (
        !module.isComplete &&
        module.isRequired &&
        module.navUrl !== dashboardUrl.authenticate
      ) {
        arr.push({ name: module.name, navUrl: module.navUrl });
      }
    });
    setPendingModules(arr);
    return arr;
  }
  return (
    <div>
      <div className="prflHome">
        <div className="prflHeading">
          <h2>Authenticate &amp; Submit</h2>
        </div>
        <div className="banner">
          <img className="bannerImg" src={esignBanner} alt="" aria-hidden="true" />
        </div>
        {pendingModules && (
          <>
            {pendingModules.length > 0 ? (
              <PendingModules pendingModulesList={pendingModules} />
            ) : (
              <>
                <KRAAuthenticateForm />
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};
export default KraAuthenticateHome;
